import React, { useState, useContext, useEffect } from "react";
import { Box, Typography } from "@mui/material";

import GeneralContext from "../GeneralContext/GeneralContext";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

import PageBody from "../GeneralComponents/PageBody";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import SagecFAQ from "./SagecFAQ"
import axios from "../../api/axios";

import {
  ROL_OP_ADMIN,
  ROL_OP_INS,
  ROL_ADMIN_SUBTEL,
  ROL_VAL_SUBTEL,
  ROL_ADMIN,
} from "../../Constants/Constants";


const Support = () => {
  const { pageTitle, setPageTitle, includeRol } = useContext(GeneralContext);
  const [sended, setSended] = useState(false);
  const [loading, setLoading] = useState(false);
    const [ticketID, setTicketID] = useState("");


  const [formData, setFormData] = useState(
        {
            "title": "",
            "description": "",
        }
    )


  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    axios
      .createTicket(formData)
      .then((response) => {
        setTicketID(response.data.id)
        setSended(true);
      })
      .catch((error) => {
      })
      .finally(() => {
        setLoading(false);
      });


  };

  useEffect(() => {
    setPageTitle("Contacto de Soporte");
  }, [pageTitle, setPageTitle]);

  return (
    <PageBody>
      <PageBgBlock pad="3rem 6rem">
        <Box>
          <Typography variant="h1" align="left" sx={{ marginBottom: "1.2rem" }}>
            AYUDA Y SOPORTE
          </Typography>

          <Box
            justifyContent="left"
            sx={{ margin: "0 auto", display: "flex" }}
          >
            <Typography
              variant="body"
              align="left"
              sx={{ marginBottom: "1rem" }}
            >
Mediante este formulario, puede detallarnos su situación con la plataforma SAGEC. Desde el área de soporte, recibiremos su caso y le enviaremos un ID de ticket para su registro. En caso de que no lo contactemos por correo o teléfono, puede enviar un mensaje con su ID de ticket a este correo.            </Typography>
          </Box>
          <Box
            sx={{ width: '100%', margin: "0 auto", display: "flex" }}
          >
            <Typography
              variant="body"
              align="left"
              sx={{ marginBottom: "2rem" }}
            >
              <b>Administrador SAGEC: soporte.sagec@blueshadows.cl</b>
            </Typography>
          </Box>

          <form onSubmit={handleSubmit}>
          <FormControl
              sx={{ width: "100%", maxWidth: "100%", marginBottom: "39px" }}
            >
              <TextField
                required
                disabled={sended}
                id="outlined-required"
                label="Asunto"
                size="small"
                value={formData.title}
                onChange={(newValue) => setFormData({ ...formData, title: newValue.target.value })}
              />
            </FormControl>
            <FormControl
              sx={{ width: "100%", maxWidth: "100%", marginBottom: "39px" }}
            >
              <TextField
                disabled={sended}
                required
                multiline
                rows={4}
                id="outlined-required"
                label="Descripción"
                placeholder="Escriba aquí su situación"
                size="small"
                value={formData.description}
                onChange={(newValue) => setFormData({ ...formData, description: newValue.target.value })}
              />
            </FormControl>
            {!sended ? (
            <PageButtonBlack loading={loading}  width="312px">
              Enviar
            </PageButtonBlack>)
            :
            (<><PageButtonBlack onClick={handleSubmit} 
                loading={sended} width="312px">
              Enviar
            </PageButtonBlack>
            <Box sx={{padding: "2rem", marginTop: "2rem", borderRadius: "0.5rem", backgroundColor: "#E4E4E4", textAlign: "center"}}>
              <Typography
              variant="body"
            >
              Su ID de ticket de soporte es:  <b>{ticketID}</b>
            </Typography>

            </Box></>)

            }
            

          </form>
        </Box>
      </PageBgBlock>
      <Box sx={{mb: 4}}></Box>
      {includeRol([ROL_ADMIN]) ? <SagecFAQ/> : null} 
    </PageBody>
  );
};

export default Support;
